import { Component, OnInit } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { ModalController, Platform } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { FaqsPagePage } from 'src/app/account/faqs-page/faqs-page.page';
import { HelpTicketPage } from 'src/app/account/help-ticket/help-ticket.page';
import { AuthenticationStore } from 'src/app/stores/authentication.store';
import { PaymentMethod, WalletStore } from 'src/app/stores/wallet.store';
import { imageUrl } from 'src/environments/environment';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {
  paymentMethodList: PaymentMethod;
  imageUrl = imageUrl;
  currentYear = new Date().getFullYear();
  constructor(
    private walletStore: WalletStore,
    public translate: TranslateService,
    public platform: Platform,
    private userAuth: AuthenticationStore,
    private modalCtrl: ModalController,
    private route: Router
  ) {}

  ngOnInit() {
    this.getPaymentMethod();
  }
  async getPaymentMethod() {
    this.paymentMethodList = await this.walletStore.paymentMethod();
  }

  async openHelp(type) {
    if (type === 0) {
      if (this.platform.is('mobile')) {
        var resp = await this.userAuth.requiredLogin();
        if (resp) {
          const navigationExtras: NavigationExtras = {
            state: {
              type: type,
            },
          };
          this.route.navigate(['/account/help-ticket'], navigationExtras);
        }
      } else {
        var resp = await this.userAuth.requiredLogin();
        if (resp) {
          const modal = await this.modalCtrl.create({
            component: HelpTicketPage,
            cssClass: 'Successful-Created',
            componentProps: {
              pageType: type,
            },
          });
          modal.present();
        }
      }
    } else {
      if (this.platform.is('mobile')) {
        this.route.navigate(['/account/faqs-page']);
      } else {
        const modal = await this.modalCtrl.create({
          component: FaqsPagePage,
          cssClass: 'Successful-Created',
          componentProps: {
            modalType: true,
          },
        });
        modal.present();
      }
    }
  }

  async openSeller() {
    var resp = await this.userAuth.requiredLogin();
    if (resp) {
      if (this.userAuth.userInfo && this.userAuth.userInfo.seller) {
        this.route.navigate(['/seller/my-shop']);
      } else {
        this.route.navigate(['/seller']);
      }
    }
  }
}
